/**
 *
 * @desc:支付方式相关配置
 * @author: haifn
 * @time: 2019-06-24 14:50
 *
 * @transfer:对公转账
 * @weixin:微信app原生支付 - 移动端
 * @weixin_h5:微信h5支付 - 移动端
 * @weiXinQr:微信扫码支付 - 桌面端
 * @weiXinApp:微信小程序支付 - 微信小程序端
 * @alipay:支付宝
 * @paypal:paypal
 * @creditcard:信用卡
 * @sofortBanking:本土支付
 * @ideal:本土支付
 * @kakaoPay: 韩国本土支付
 * @naverPay:韩国本土支付
 *
 */

import { CountryCode, getCache, getCurrency, getLANG, isEmpty, isMobile } from '@/utils';
import { _8kLivePid } from '@/utils/configs/8kLive.config';
import { sortBy } from 'lodash';
import ThirdPartyPlatformConfig from './ThirdPartyPlatform.config';
import { armsErrorSend } from '../libs/armsErrorSend';
import ApplePay from '../payment/ApplePay.config';
import GooglePayConfig from '../payment/GooglePay.config';

const isSafariReg = /^((?!chrome|android).)*safari/i; // 判断当前浏览器是否为safari
const CountryCurrency = getCurrency();
// const X_Language = getLang();
const cache = getCache();
let _LANG = getLANG();
const isMob = isMobile();

// 商城支持的卡种信息、和后端credit_card_name对齐
export const CARD_TYPE = {
  visa: 'visa',
  mastercard: 'mastercard',
  master: 'mastercard',
  JCB: 'jcb',
  AE: 'ae',
  dinersclubs: 'diners',
  discover: 'discover',
  maestro: 'maestro',
  unionpay: 'unionpay',
};

export const PAYMENT_ICON = {
  visa: 'https://res.insta360.com/static/f629f3d51e9a0bd49324db73dc137c9c/Visa.png',
  master: 'https://res.insta360.com/static/e282e964df91b0d5434f2cef11e34c3a/Mastercard.png',
  mastercard: 'https://res.insta360.com/static/e282e964df91b0d5434f2cef11e34c3a/Mastercard.png', // cko传入
  MC: 'https://res.insta360.com/static/e282e964df91b0d5434f2cef11e34c3a/Mastercard.png', // 钱海传入
  maestro: 'https://res.insta360.com/static/9ac51d4cf1d4bd546b24eb9d16d95c92/Maestro.png',
  CB: 'https://res.insta360.com/static/4d18fbf913ca1ac8790bc98e6468dedb/CB.png',
  AE: 'https://res.insta360.com/static/e322d4029c8c31129d065bf3c72c477d/AE.png',
  'AMERICAN EXPRESS': 'https://res.insta360.com/static/e322d4029c8c31129d065bf3c72c477d/AE.png',
  discover: 'https://res.insta360.com/static/4f8cb175c4602aa152151a7634bc09b1/Discover.png',
  diners: 'https://res.insta360.com/static/e0d099b00e8e1245ab366e1df8f3a246/DinersClubs.png',
  dinersclubs: 'https://res.insta360.com/static/e0d099b00e8e1245ab366e1df8f3a246/DinersClubs.png',
  JCB: 'https://res.insta360.com/static/fc241d73ce86d9a36d0c70e896ebd037/JCB.png',
  Paypal: 'https://res.insta360.com/static/17e3dd7345028c706cd54f35821ca0b6/Paypal.png',
  ideal: 'https://res.insta360.com/static/77029ea2b53ba96596298c3d1670587e/IDEAL.png',
  SofortBanking: 'https://res.insta360.com/static/9a948e21453f6c0142fa5ce8ed468c77/SofortBanking.png',
  AliPay: 'https://res.insta360.com/static/628b67c9002b8dbd7c2284951b26696d/alipay.png',
  WeixinPay: 'https://res.insta360.com/static/d558cffde8c10b86bd0fc2eadc937ee8/wxpay.png',
  Transfer: 'https://res.insta360.com/static/52b0dc2402a37fa951560807219d0424/transfer.png',
  unionpay: 'https://res.insta360.com/static/0789c96bbd72677cdfb235395cf37303/Unionpay.png',
  'CUP': 'https://res.insta360.com/static/0789c96bbd72677cdfb235395cf37303/Unionpay.png',
  'CHINA UNION PAY': 'https://res.insta360.com/static/0789c96bbd72677cdfb235395cf37303/Unionpay.png',
  KakaoPay: 'https://res.insta360.com/static/6cdbccb88ef8d85ce53dacb2f34cd07c/kr_kkp.png',
  NaverPay: 'https://res.insta360.com/static/ca4a3848fd8fe9a52f34dd2ba7b70e85/kr_np.png',
  klarna: 'https://res.insta360.com/static/50e447402a70a2889b81bd66cc78f645/klarna.png',
  KB: 'https://res.insta360.com/static/72332592d9ded4830a26ac60a7874e22/kr_kb.png',
  Hc: 'https://res.insta360.com/static/33a77f9559172a67c441ef6117ce5512/kr_hc.png',
  Samsung: 'https://res.insta360.com/static/ca4cdfb16a45c4bca583089c7141da97/sumsung.png',
  SC: 'https://res.insta360.com/static/70cac60675d312ff7ddec5c990b79c46/kr_sc.png',
  BC: 'https://res.insta360.com/static/7a65483ddc4b34fb742d91171d87b48b/kr_bc.png',
  LC: 'https://res.insta360.com/static/8fa0b087c7cd824f1d225ecf3c0b3111/kr_lc.png',
  ApplePay: 'https://res.insta360.com/static/810d3290ccda383d9cce0d1301393569/ApplePay.png',
  GooglePay: 'https://res.insta360.com/static/28ee0ea4e75958c412d33d1a06cafcdb/GooglePay.png',
  krCreditCardIcon: 'https://res.insta360.com/static/0a5f4c0926dbdad185f2df3e535ff71f/ic.png',
  krCreditCardOthers: _LANG['payments.methods.kr_creditCard_others'],
};
// 获取云存储商品购买支持的渠道type
export const cloudServicePayment = ['paypal', 'creditCard', 'ApplePay', 'google_pay', 'klarna'];

/**
 * 排序支付图标，目前共有7种支付组合排序
 * 类型3排序同1，类型8排序同5，排序6不存在
 * https://arashivision.feishu.cn/wiki/PScXwthLcicioekzyfncGOA6nlf?sheet=kxWNtp
 */
const orderConfig = {
  [PAYMENT_ICON.AliPay]: {
    groupType6: 1,
  },
  [PAYMENT_ICON.WeixinPay]: {
    groupType6: 2,
  },
  [PAYMENT_ICON.krCreditCardIcon]: {
    groupType5: 1,
  },
  [PAYMENT_ICON.NaverPay]: {
    groupType5: 2,
  },
  [PAYMENT_ICON.KakaoPay]: {
    groupType5: 3,
  },
  [PAYMENT_ICON.visa]: {
    groupType1: 1,
    groupType2: 1,
    groupType3: 1,
    groupType4: 1,
    groupType5: 4,
    groupType6: 3,
    groupType7: 1,
    groupType8: 1,
    groupType9: 1,
    groupType10: 1,
    groupType11: 1,
  },
  [PAYMENT_ICON.Paypal]: {
    groupType1: 2,
    groupType2: 2,
    groupType3: 2,
    groupType4: 2,
    groupType5: 7,
    groupType7: 2,
    groupType8: 3,
    groupType9: 3,
    groupType10: 2,
    groupType11: 2,
  },
  [PAYMENT_ICON.ApplePay]: {
    groupType2: 3,
    groupType3: 3,
    groupType5: 6,
    groupType7: 3,
    groupType8: 4,
    groupType9: 4,
    groupType10: 3,
    groupType11: 3,
  },
  [PAYMENT_ICON.GooglePay]: {
    groupType3: 4,
    groupType4: 3,
    groupType7: 5,
    groupType8: 6,
    groupType9: 5,
    groupType10: 4,
    groupType11: 5,
  },
  [PAYMENT_ICON.master]: {
    groupType1: 3,
    groupType2: 4,
    groupType3: 5,
    groupType4: 4,
    groupType5: 5,
    groupType6: 4,
    groupType7: 6,
    groupType8: 2,
    groupType9: 2,
    groupType10: 6,
    groupType11: 7,
  },
  [PAYMENT_ICON.maestro]: {
    groupType1: 9,
    groupType2: 10,
    groupType3: 11,
    groupType4: 10,
    groupType5: 13,
    groupType6: 10,
    groupType7: 12,
    groupType8: 14,
    groupType9: 12,
    groupType10: 13,
    groupType11: 13,
  },
  [PAYMENT_ICON.AE]: {
    groupType1: 4,
    groupType2: 5,
    groupType3: 6,
    groupType4: 5,
    groupType5: 8,
    groupType6: 5,
    groupType7: 7,
    groupType8: 9,
    groupType9: 7,
    groupType10: 7,
    groupType11: 8,
  },
  [PAYMENT_ICON.unionpay]: {
    groupType1: 5,
    groupType2: 6,
    groupType3: 7,
    groupType4: 6,
    groupType5: 9,
    groupType6: 6,
    groupType7: 8,
    groupType8: 10,
    groupType9: 8,
    groupType10: 8,
    groupType11: 9,
  },
  [PAYMENT_ICON.dinersclubs]: {
    groupType1: 6,
    groupType2: 7,
    groupType3: 8,
    groupType4: 7,
    groupType5: 10,
    groupType6: 7,
    groupType7: 8,
    groupType8: 11,
    groupType9: 9,
    groupType10: 9,
    groupType11: 10,
  },
  [PAYMENT_ICON.discover]: {
    groupType1: 7,
    groupType2: 8,
    groupType3: 9,
    groupType4: 8,
    groupType5: 11,
    groupType6: 8,
    groupType7: 10,
    groupType8: 12,
    groupType9: 10,
    groupType10: 10,
    groupType11: 11,
  },
  [PAYMENT_ICON.JCB]: {
    groupType1: 8,
    groupType2: 9,
    groupType3: 10,
    groupType4: 9,
    groupType5: 12,
    groupType6: 9,
    groupType7: 11,
    groupType8: 13,
    groupType9: 11,
    groupType10: 11,
    groupType11: 12,
  },
  [PAYMENT_ICON.klarna]: {
    groupType7: 4,
    groupType8: 5,
    groupType11: 4,
  },
  [PAYMENT_ICON.SofortBanking]: {
    groupType8: 7,
    groupType9: 6,
    groupType10: 5,
    groupType11: 6,
  },
};

/**
 * 排序支付图标方法
 */
const sortPaymentIcons = (paymentIcons = [], countryCode) => {
  let orderType = 'groupType3';
  switch (true) {
    case ['ID', 'PH', 'RU'].includes(countryCode):
      orderType = 'groupType1';
      break;
    case ['MO'].includes(countryCode):
      orderType = 'groupType2';
      break;
    case ['IN', 'BN', 'TH', 'AD'].includes(countryCode):
      orderType = 'groupType4';
      break;
    case ['KR'].includes(countryCode):
      orderType = 'groupType5';
      break;
    case ['CN'].includes(countryCode):
      orderType = 'groupType6';
      break;
    case ['FI', 'IE', 'GB', 'ES', 'FR', 'IT', 'PT', 'SK'].includes(countryCode):
      orderType = 'groupType7';
      break;
    case ['BE', 'AT', 'DE', 'NL'].includes(countryCode):
      orderType = 'groupType11';
      break;
    default:
      orderType = 'groupType3';
      break;
  }

  const icons = sortBy(paymentIcons, (o) => {
    if (!orderConfig[o]) return 99;
    if (!orderConfig[o]?.[orderType]) return 98;
    return orderConfig[o]?.[orderType];
  });
  return icons;
};

/**
 *
 * @desc: 对公转账支持的货币
 * @author: haifn
 * @time: 2021/7/14 6:10 下午
 *
 */
const SupportTransferCurrency = ['CNY', 'GBP', 'EUR', 'AUD', 'CAD', 'HKD', 'JPY', 'USD', 'SGD', 'TWD', 'KRW'];

// 订阅卡种配置，美国有不同的商户账号，支持卡种也不一样。 如果没有isOcean，则默认为不区分渠道，信用卡展示
export const subscriptionCardType = ({ isOcean }) => {
  const oceanSubscriptionCardType = {
    US: ['visa', 'master'], // 'JCB','AE', 'dinersclubs', 'discover', 美国暂时不支持钱海支付云存，所以只有cko
    default: [`visa`, `master`, 'maestro', `AE`, `JCB`, 'unionpay'],
  };

  let ocean = oceanSubscriptionCardType[CountryCode] ?? oceanSubscriptionCardType.default;
  let checkout = ['visa', 'master'];

  switch (true) {
    case isOcean:
      return ocean;
    case typeof isOcean !== 'undefined' && !isOcean:
      return checkout;
    default:
      return ocean;
  }
};

// 获取信用卡卡种配置
const getCartType = ({ CountryCode, isSubscription }) => {
  let cardType = [];
  let cartIcon = [];
  switch (CountryCode) {
    case 'US':
      cardType = ['AE', 'dinersclubs', 'discover', 'visa', 'master', 'JCB']; // 美国主体不支持：'maestro','unionpay'
      break;
    case 'GB':
      cardType = ['AE', 'visa', 'master', 'maestro', 'dinersclubs', 'discover', 'JCB', 'unionpay'];
      break;
    case 'FR':
      cardType = ['CB', 'visa', 'master', 'maestro', 'AE', 'dinersclubs', 'discover', 'JCB', 'unionpay'];
      break;
    default:
      cardType = ['visa', 'master', 'maestro', 'AE', 'unionpay', 'dinersclubs', 'discover', 'JCB'];
      break;
  }

  if (isSubscription) {
    const subType = subscriptionCardType({ CountryCode });
    cardType = cardType.filter((key) => subType.includes(key));
  }
  cartIcon = cardType.map((key) => PAYMENT_ICON[key]);
  cartIcon = sortPaymentIcons(cartIcon, CountryCode);
  return { cardType, cartIcon };
};

// 支付方式
export function paymentMethods({ CountryCode, isSubscription }) {
  return {
    creditCard: {
      type: 'creditCard',
      paymentType: 1,
      title: _LANG['payments.methods.creditCard'],
      ...getCartType({ CountryCode, isSubscription }),
    },
    ApplePay: {
      type: 'ApplePay',
      paymentType: 3,
      title: _LANG['payments.methods.applePay'],
      tip: _LANG['payments.methods.applePay_tips'],
      cartIcon: [PAYMENT_ICON.ApplePay],
    },
    GooglePay: {
      type: 'google_pay',
      paymentType: 3,
      title: _LANG['payments.methods.googlepay'],
      tip: _LANG['payments.methods.googlepay_tip'],
      cartIcon: [PAYMENT_ICON.GooglePay],
    },
    krCreditCard: {
      type: 'korCreditCard',
      paymentType: 0,
      title: _LANG['payments.methods.kr_creditCard'],
      tip: _LANG['payments.methods.kr_creditCard_tip'],
      cartIcon: [
        PAYMENT_ICON.KB,
        PAYMENT_ICON.Hc,
        PAYMENT_ICON.Samsung,
        PAYMENT_ICON.SC,
        PAYMENT_ICON.BC,
        PAYMENT_ICON.LC,
        PAYMENT_ICON.krCreditCardOthers,
      ],
    },
    KakaoPay: {
      type: 'kakaoPay',
      paymentType: 3,
      title: _LANG['payments.methods.kakaoPay'],
      tip: _LANG['payments.methods.kakaoPayTips'],
      cartIcon: [PAYMENT_ICON.KakaoPay],
    },
    NaverPay: {
      type: 'naverPay',
      paymentType: 3,
      title: _LANG['payments.methods.naverPay'],
      tip: _LANG['payments.methods.naverPayTips'],
      cartIcon: [PAYMENT_ICON.NaverPay],
    },
    paypal: {
      type: 'paypal',
      paymentType: 2,
      title: _LANG['payments.methods.paypal'],
      tip: _LANG['payments.methods.paypal_tips'],
      cartIcon: (function () {
        return [PAYMENT_ICON.Paypal];
      })(),
    },
    klarna: {
      type: 'klarna',
      paymentType: 2,
      title: _LANG['payments.methods.klarna'],
      tip: _LANG['payments.methods.klarna_tip'],
      cartIcon: (() => {
        return [PAYMENT_ICON.klarna];
      })(),
    },
    alipay: {
      type: 'alipay',
      paymentType: 3,
      title: _LANG['payments.methods.alipay'],
      tip: _LANG['payments.methods.alipay_tips'],
      cartIcon: (function () {
        return [PAYMENT_ICON.AliPay];
      })(),
    },
    weiXin: {
      type: 'weiXin',
      paymentType: 3,
      title: _LANG['payments.methods.weixinPay'],
      tip: _LANG['payments.methods.weixinPay_tips'],
      cartIcon: (function () {
        return [PAYMENT_ICON.WeixinPay];
      })(),
    },
    sofortBanking: {
      type: 'sofortBanking',
      paymentType: 3,
      title: 'Sofortbanking',
      tip:
        _LANG['payments.methods.localPayment_tips'].split('&&')[0] +
        ' Sofortbanking ' +
        _LANG['payments.methods.localPayment_tips'].split('&&')[1],
      cartIcon: (function () {
        return [PAYMENT_ICON.SofortBanking];
      })(),
    },
    ideal: {
      type: 'ideal',
      paymentType: 0,
      title: 'iDEAL',
      tip:
        _LANG['payments.methods.localPayment_tips'].split('&&')[0] +
        ' iDEAL ' +
        _LANG['payments.methods.localPayment_tips'].split('&&')[1],
      cartIcon: (function () {
        return [PAYMENT_ICON.ideal];
      })(),
    },
    transfer: {
      type: 'transfer',
      paymentType: 0,
      title: _LANG['payments.methods.transfer'],
      tip: _LANG['payments.methods.transfer_tips'],
      cartIcon: (function () {
        return [PAYMENT_ICON.Transfer];
      })(),
    },
  };
}

/**
 * @description 获取当前国家的支付列表
 * - 支付方式列表展示页面：1、结账页； 2、二次支付页； 3、支付结果页（移动端）
 * @param {*} country
 * @param {*} orderInfoFromPay （二次支付）订单支付信息 通常取simpleOrderDetail
 * @param {*} orderInfoFromConfirm 结账页信息 /【其他产品信息】 传入handleCalcOrderConfirmPayment confirm页面结算总价
 * @param {*} currentPageCartItems 结账页 / 购物车页商品items 动态判断支付渠道展示情况
 * @param {boolean} isSubscription 是否包含订阅商品
 * @returns
 * 变更一定要更新这个统计文档：（第二页还有排序顺序）https://arashivision.feishu.cn/wiki/DtCVwFR4wiqgoWkQml1cFAsIn1f?sheet=c0dfBA
 * ---
 */
export function getPaymentMethods({
  country,
  orderInfoFromPay = {},
  orderInfoFromConfirm = {},
  currentPageCartItems = [],
  isFilterRepairStock,
  isSubscription,
  fromGetIconList = false,
}) {
  let methods = [];
  const CountryCode = orderInfoFromPay?.area ?? country.code;
  const _paymentMethods = paymentMethods({ CountryCode, isSubscription });

  switch (CountryCode) {
    case 'US':
      methods = [_paymentMethods.creditCard, _paymentMethods.paypal];
      break;
    case 'GB':
      methods = [_paymentMethods.creditCard, _paymentMethods.paypal];
      break;
    case 'DE':
      methods = [_paymentMethods.creditCard, _paymentMethods.paypal];
      break;
    case 'NL':
      methods = [_paymentMethods.creditCard, _paymentMethods.paypal];
      break;
    case 'AT':
      methods = [_paymentMethods.creditCard, _paymentMethods.paypal];
      break;
    case 'FR':
    case 'BE':
    case 'ES':
      methods = [_paymentMethods.creditCard, _paymentMethods.paypal];
      break;
    case 'IT':
      methods = [_paymentMethods.creditCard, _paymentMethods.paypal];
      break;
    case 'CN':
      methods = [_paymentMethods.alipay, _paymentMethods.weiXin];
      break;
    case 'KR':
      methods = [
        _paymentMethods.krCreditCard,
        _paymentMethods.NaverPay,
        _paymentMethods.creditCard,
        _paymentMethods.KakaoPay,
        _paymentMethods.paypal,
      ];
      break;
    case 'RU':
      methods = [];
      break;
    default:
      methods = [_paymentMethods.creditCard, _paymentMethods.paypal];
  }

  try {
    const { orderPaymentInfo = {} } = orderInfoFromPay || {};

    // paypal支付序号
    const paypalIndex = methods.findIndex((d) => d.type === 'paypal');

    // 处理klarna支付，klarna支付开通的国家多达10几个，单独处理
    if (
      // eslint-disable-next-line no-use-before-define
      enableKlarna({
        code: CountryCode,
        amount: isEmpty(orderPaymentInfo) ? orderInfoFromConfirm.total : orderPaymentInfo.totalAmount,
        currency: isEmpty(orderPaymentInfo) ? orderInfoFromConfirm.currency : orderPaymentInfo.currency,
        p_c_ids: currentPageCartItems.map((d) => ({ cid: d.commodityId, pid: d.productId })),
      })
    ) {
      if (paypalIndex > -1) {
        methods.splice(paypalIndex + 1, 0, _paymentMethods.klarna);
      } else {
        methods.push(_paymentMethods.klarna);
      }
    }

    // 处理韩国本土信用卡支付
    const isKR = CountryCode === 'KR';
    if (isKR) {
      const amount = isEmpty(orderPaymentInfo) ? orderInfoFromConfirm.total : orderPaymentInfo.totalAmount;

      if (amount && amount < 200) {
        const index = methods.findIndex((d) => d.type === 'korCreditCard');
        methods.splice(index, 1);
      }
    }

    // 处理Apple Pay 支付
    const applePayAvailable = ApplePay.enable({ CountryCode, fromGetIconList });
    if (applePayAvailable) {
      // 如果是KR，则放PP前面
      methods.splice(paypalIndex + (isKR ? 0 : 1), 0, _paymentMethods.ApplePay);
    }

    // 处理对公转账
    // 结账页直接获取CountryCurrency
    // 订单二次支付页页面则需要从订单信息去匹配Currency，订单货币
    let transferCurrency = orderInfoFromPay?.orderPaymentInfo?.currency ?? CountryCurrency;

    if (SupportTransferCurrency.includes(transferCurrency) && !['CN'].includes(CountryCode)) {
      methods.push(paymentMethods({ CountryCode }).transfer);
    }

    // 处理Google Pay 支付，一定要放在所有支付渠道的处理之后，因为它默认会插入顺序是倒数第二个
    const googlePayAvailable = GooglePayConfig.getGooglePayEnable(CountryCode);
    if (googlePayAvailable) {
      const applePayIndex = methods.findIndex((item) => item.type === 'ApplePay');
      const klarnaIndex = methods.findIndex((item) => item.type === 'klarna');
      const insertIndex = Math.max(applePayIndex, klarnaIndex) === -1 ? -1 : Math.max(applePayIndex, klarnaIndex) + 1;
      // PC端部分safari浏览器不支持google pay，所有safari浏览器暂时不显示
      const notShowGooglePayMethod =
        !GooglePayConfig.GoolePayReady || (!isMob && isSafariReg.test(navigator.userAgent));
      if (fromGetIconList) {
        methods.splice(insertIndex, 0, _paymentMethods.GooglePay);
      } else if (!notShowGooglePayMethod) {
        methods.splice(insertIndex, 0, _paymentMethods.GooglePay);
      }
    }

    // 安卓端 && APP环境 不支持scheme协议，只能隐藏微信，或者APP端做兼容
    const UA = typeof window === 'undefined' ? '' : navigator.userAgent;
    const isAndroid = UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1;
    const isApp = cache.getCookie('insta_app_name');
    if (isAndroid && isApp) {
      methods = methods.filter((o) => o.type !== 'weiXin');
    }

    // Titan和8k直播价值过高只能对公转账
    const hasTitan =
      orderInfoFromPay?.orderItemInfos?.find((o) => o.productId === 10) ||
      currentPageCartItems?.find((o) => o.productId === 10);
    const has8kLive =
      orderInfoFromPay?.orderItemInfos?.find((o) => o.productId === _8kLivePid) ||
      currentPageCartItems.find((o) => o.productId === _8kLivePid);
    if (hasTitan || has8kLive) {
      if (!methods.some((d) => d.type === 'transfer')) {
        methods.push(paymentMethods({ CountryCode }).transfer);
      }
      methods = methods.filter((o) => ['transfer', 'ApplePay'].includes(o.type));
    }

    // 香港主体销售返修库存不允许用paypal支付
    if (isFilterRepairStock) {
      methods = methods.filter((o) => o.type !== 'paypal');
    }

    methods.forEach((method) => (method.cartIcon = method.cartIcon.filter((icon) => !!icon)));
    return methods;
  } catch (e) {
    armsErrorSend(e, { filename: 'payment methods获取错误' });
    return methods.filter((d) => !!d);
  }
}

// Klarna配置
export const klarnaConfig = {
  enableCountries: ['AT', 'NL', 'FI', 'IE', 'BE', 'GB', 'DE', 'ES', 'FR', 'IT', 'PT', 'SK'],
  enableSubscription: ['AT', 'FI', 'DE'], // 支持订阅支付的国家
  merchantMap: {
    'European': ['FI', 'GB', 'IE', 'AT', 'BE', 'DE', 'ES', 'FR', 'IT', 'NL', 'PT', 'SK'],
    'US': ['US'],
    'AU': ['AU', 'NZ'],
  },
  payment: {
    'US': {
      currency: 'USD',
      locale: 'en-US',
      amount: [0, 4000],
    },
    'FI': {
      currency: 'EUR',
      locale: 'en-FI',
      amount: [0, 10000],
    },
    'GB': {
      currency: 'GBP',
      locale: 'en-GB',
      amount: [0, 4000],
    },
    'IE': {
      currency: 'EUR',
      locale: 'en-IE',
      amount: [0, 4000],
    },
    'AT': {
      currency: 'EUR',
      locale: 'de-AT',
      amount: [0, 10000],
    },
    'BE': {
      currency: 'EUR',
      locale: 'en-BE',
      amount: [0, 10000],
    },
    'DE': {
      currency: 'EUR',
      locale: 'de-DE',
      amount: [0, 10000],
    },
    'ES': {
      currency: 'EUR',
      locale: 'es-ES',
      amount: [0, 4000],
    },
    'FR': {
      currency: 'EUR',
      locale: 'fr-FR',
      amount: [0, 4000],
    },
    'IT': {
      currency: 'EUR',
      locale: 'it-IT',
      amount: [0, 4000],
    },
    'NL': {
      currency: 'EUR',
      locale: 'en-NL',
      amount: [0, 10000],
    },
    'PT': {
      currency: 'EUR',
      locale: 'en-PT',
      amount: [0, 4000],
    },
    'SK': {
      currency: 'EUR',
      locale: 'en-SK',
      amount: [0, 4000],
    },
  },
};

/**
 * 获取支付选项ICON 参数同 getPaymentMethods ，以及LANG
 * @return {string[]} string Country 若是则返回国家地区信息,否则返回空
 */
export function getCartPaymentIcon(data = {}) {
  try {
    _LANG = data.LANG;
    let icons = [];
    let hasKRcreditCard = false;
    // 俄罗斯不展示支付ICON
    if (data.country?.code === 'RU') return [];
    // 加多一个来源进行区分，ApplePay即使在不支持的设备上也展示ICON。
    data.fromGetIconList = true;
    let methods = getPaymentMethods(data);

    // 购物车icon中：云存储不支持的支付方式不显示
    if (data.from === 'cart' && data.isSubscription) {
      methods = methods.filter((d) =>
        d.type === 'klarna'
          ? klarnaConfig.enableSubscription.includes(data.country?.code)
          : cloudServicePayment.includes(d.type)
      );
    }

    methods.forEach((o) => {
      switch (o.type) {
        case 'korCreditCard':
          hasKRcreditCard = true;
          return;
        case 'transfer':
          return;
        default:
          icons = [...icons, ...o.cartIcon];
          break;
      }
    });

    if (data.country?.code === 'KR' && hasKRcreditCard) {
      icons.splice(1, 0, PAYMENT_ICON.krCreditCardIcon);
    }

    icons = sortPaymentIcons(icons, data.country?.code);

    return icons;
  } catch (e) {
    return [];
  }
}

/**
 * 获取利益点弹窗支付方式ICON 参数同 getPaymentMethods;获取规则如下:
 *  1. Pay by card         展示顺序: Visa, Mastercard, Maestro, American Express, UnionPay, Diners, Discover, JCB
 *  2. Buy now, pay later  展示顺序: Paypal, Klarna
 *  3. Pay your way        展示顺序: Apple Pay, Google Pay, Naver Pay, Kakao Pay, 韩国本土信用卡, CB, 支付宝 ,微信支付
 * @param {} data
 */
export function getSalePointPaymentIcon(data = {}) {
  try {
    // 加多一个来源进行区分，ApplePay即使在不支持的设备上也展示ICON。
    data.fromGetIconList = true;
    // 获取当前地区的支付方式
    const paymentMethod = getPaymentMethods(data);
    // 获取所有的支付ICON配置
    const _paymentMethods = paymentMethods({ CountryCode: data.country?.code });

    // 对支付方式 paymentType 进行分组
    const paymentMethodGroups = {
      1: [],
      2: [],
      3: [],
    };
    paymentMethod.forEach((item) => {
      if (!paymentMethodGroups[item.paymentType]) {
        paymentMethodGroups[item.paymentType] = [];
      }
      paymentMethodGroups[item.paymentType].push(item);
    });

    // 支付方式1无需排序处理，已经按照顺序展示
    // 支付方式2按照固定顺序排序处理
    paymentMethodGroups[2].sort((a, b) => {
      const typeOrder = [_paymentMethods.paypal.type, _paymentMethods.klarna.type];
      return typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type);
    });
    // 支付方式3按照固定顺序排序处理
    paymentMethodGroups[3].sort((a, b) => {
      const typeOrder = [
        _paymentMethods.ApplePay.type,
        _paymentMethods.GooglePay.type,
        _paymentMethods.NaverPay.type,
        _paymentMethods.KakaoPay.type,
        _paymentMethods.alipay.type,
        _paymentMethods.weiXin.type,
      ];
      return typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type);
    });

    // 支付文案1 针对支付方式2没有PayPal分期付，而又有PayPal普通支付，将PayPal放进 Pay your way中代表提供多渠道支付方式
    // 详见文档:https://arashivision.feishu.cn/wiki/wikcnQbdupHZbQ2RXT5syzBm4Oc?sheet=4OssDg
    if (['AT', 'FI', 'IE', 'NL', 'PT', 'SK', 'BE'].includes(data.country?.code)) {
      // 满足该条件的国家一定有PayPal支付方式; 经过排序的paymentMethodGroups[2]第一项一定为PayPal; 直接执行下面代码
      paymentMethodGroups[3].unshift(paymentMethodGroups[2].shift());
    }

    // 获取支付方式下ICON，简化页面展示流程
    const cartIconsGroups = {
      1: [],
      2: [],
      3: [],
    };
    for (const type in paymentMethodGroups) {
      if (parseInt(type) !== 0 && paymentMethodGroups[type].length > 0) {
        const itemsOfType = paymentMethodGroups[type];
        itemsOfType.forEach((item) => {
          cartIconsGroups[type].push(...item.cartIcon);
        });
      }
    }

    // 支付文案2 需要将Paypal添加到支付方式3展示; Paypal全球全量上线除'CN'地区
    // 详见文档: https://arashivision.feishu.cn/wiki/wikcnQbdupHZbQ2RXT5syzBm4Oc?sheet=vqsNJy
    if (data.type === 2 && data.country?.code !== 'CN') {
      // 直接添加paypal到支付方式3展示
      cartIconsGroups[3].unshift(PAYMENT_ICON.Paypal);
    }
    // 针对FR法国支付方式CB展示特殊处理
    if (data.country?.code === 'FR') {
      cartIconsGroups[3].push(cartIconsGroups[1].pop());
    }
    // 针对韩国支付方式特殊处理，添加韩国本土信用卡icon
    if (data.country?.code === 'KR') {
      cartIconsGroups[3].push(PAYMENT_ICON.krCreditCardIcon);
    }

    return cartIconsGroups;
  } catch (e) {
    return {};
  }
}

// 某些产品仅能对公转账或跳转链接，不能paypal支付的需要隐藏
export const notPaypalProducts = [10, 342, 322, 325, 353, _8kLivePid];
// 允许展示paylater的国家
export const enablePaylaterCountry = ['US', 'GB', 'FR', 'DE', 'AU', 'ES', 'IT'];

// 支付账户的多语言对应
export const accountsLocales = {
  bank: _LANG['reseller.center.account.bank'],
  bank_cn: _LANG['reseller.center.account.bank_cn'],
  wxapp: _LANG['reseller.center.account.wxapp'],
  alipay: _LANG['reseller.center.account.alipay'],
  paypal: _LANG['reseller.center.account.paypal'],
};

// 银行名称
export const banks = [
  _LANG['common.bank.BOC'],
  _LANG['common.bank.CCB'],
  _LANG['common.bank.ICBC'],
  _LANG['common.bank.ABC'],
  _LANG['common.bank.CMB'],
  _LANG['common.bank.PAN'],
  _LANG['common.bank.BCM'],
  _LANG['common.bank.CMBC'],
  _LANG['common.bank.CEB'],
  _LANG['common.bank.PSBC'],
  _LANG['common.bank.HXB'],
  _LANG['common.bank.CITIC'],
  _LANG['common.bank.SPDB'],
  _LANG['common.bank.GDB'],
  _LANG['common.bank.BJB'],
  _LANG['common.bank.BHB'],
  _LANG['common.bank.JSB'],
  _LANG['common.bank.other'],
];

// 支付错误的原因回传，支付错误code对应文案
export const paymentErrCode = {
  'bank_declined': _LANG['payments.errTips.bank_declined'],
  'invalid_card_number': _LANG['payments.errTips.invalid_card_number'],
  'insufficient_funds': _LANG['payments.errTips.insufficient_funds'],
  'expired_card': _LANG['payments.errTips.expired_card'],
  'incorrect_pin': _LANG['payments.errTips.wrong_pan'],
  'restricted_card': _LANG['payments.errTips.restricted_card'],
  'invalid_card_verification_value': _LANG['payments.errTips.invalid_card_verification_value'],
  'total_amount_limit_reached': _LANG['payments.errTips.total_amount_limit_reached'],
  'wrong_pan': _LANG['payments.errTips.wrong_pan'],
  'exceeds_withdrawal_value': _LANG['payments.errTips.total_amount_limit_reached'],
  'duplicate_order': _LANG['payments.errTips.duplicate_order'],
  'other': _LANG['payments.errTips.other'],

  /** Forter失败 */
  'cancel_by_forter': '',

  /** paypal支付失败报错文案 */
  'system_error': _LANG['payments.errTips.system_error'],
  'invalid_billing_address': _LANG['payments.errTips.invalid_billing_address'],
  'city_required': _LANG['payments.errTips.city_required'],
  'postal_code_required': _LANG['payments.errTips.postal_code_required'],
  'invalid_shipping_address': _LANG['payments.errTips.invalid_shipping_address'],
  'not_support_3ds': _LANG['payments.errTips.not_support_3ds'],
  /** paypal支付失败报错文案 */
};

// p_c_ids : [{ pid, cid },...]
const getProductEnable = (p_c_ids) => {
  if (!isEmpty(p_c_ids)) {
    return p_c_ids.every((item = {}) => {
      const redirectData = ThirdPartyPlatformConfig.getRedirectData({ pid: item.pid, cid: item.cid }) || {};
      return !redirectData.url && !notPaypalProducts.includes(item.pid);
    });
  }
  return true;
};

// Klarna enable
export const enableKlarna = ({ code, currency, p_c_ids, amount }) => {
  const countryConfig = klarnaConfig.payment[code] || {};

  if (
    klarnaConfig.enableCountries.includes(code) &&
    (amount ? amount > countryConfig.amount[0] && amount <= countryConfig.amount[1] : true) &&
    (currency ? countryConfig.currency === currency : true) &&
    getProductEnable(p_c_ids)
  ) {
    return true;
  }
  return false;
};

// Paypal enable
export const enablePaypal = ({ code, p_c_ids, amount, currency }) => {
  if (
    (amount ? amount > 0 : true) &&
    enablePaylaterCountry.includes(code) &&
    getProductEnable(p_c_ids) &&
    (currency ? CountryCurrency === currency : true)
  ) {
    return true;
  }
  return false;
};

// forter接口返回值的含义
export const forterResult = {
  reject: ['DECLINE'], // 拒绝
  pass: [
    'APPROVE',
    'NOT REVIEWED',
    'VERIFICATION_REQUIRED_3DS_CHALLENGE',
    'REQUEST_SCA_EXEMPTION_TRA',
    'REQUEST_SCA_EXEMPTION_LOW_VALUE',
    'REQUEST_SCA_EXEMPTION_CORP',
    'REQUEST_SCA_EXEMPTION_TRUSTED_BENEFICIARY',
  ], // 通过
  // VERIFICATION_REQUIRED_3DS_CHALLENGE -- 需要走3ds验证 , APPROVE -- 该订单无风险 , REQUEST_SCA_EXEMPTION_TRA -- 3d豁免
  // NOT REVIEWED 默认放行
  exemption: [
    'REQUEST_SCA_EXEMPTION_TRA',
    'REQUEST_SCA_EXEMPTION_LOW_VALUE',
    'REQUEST_SCA_EXEMPTION_CORP',
    'REQUEST_SCA_EXEMPTION_TRUSTED_BENEFICIARY',
  ], // 3DS豁免
  threeDomainTrade: 'VERIFICATION_REQUIRED_3DS_CHALLENGE', // 信用卡支付threeDomainTrade
};

// 支付渠道枚举，对应运营后台
// const payChannelMap = {
//   alipay: '支付宝', // 支付宝
//   weiXin: '微信支付', // 微信app
//   weiXinQr: '微信支付', // 微信二维码
//   weixin_h5: '微信支付', // 微信h5页
//   weiXinApp: '微信支付', // 微信小程序
//   paypal: 'Paypal支付', // paypal
//   paypal_ss: 'Paypal支付', // paypal（顺势主体）
//   credit_paypal: 'Paypal分期支付', // PayPal分期付
//   credit_paypal_ss: 'Paypal分期支付', // PayPal分期付（顺势主体）
//   creditCard: '信用卡', // 信用卡（钱海）（未使用）
//   credit_card_redirect: '信用卡', // 三方跳转（钱海3方 -- 未使用）
//   credit_card_direct: '信用卡', // 直接信用卡（钱海 -- 未使用）
//   credit_card_indirect: '信用卡', // 中国地区信用卡（钱海 -- 使用中）
//   credit_card_indirect_hk: '海外信用卡', // 海外信用卡（钱海 -- 使用中）
//   sofortBanking: 'sofortBanking', // Sofortbanking（钱海）
//   ideal: 'ideal', // iDEAL（钱海）
//   union_pay: '国际银联', // 国际银联（钱海）
//   ae_discover_jcb_cup: '信用卡', // AE、Discover、JCB、Cup（钱海）  与其他信用卡收款主体不同，独立出来
//   cko_credit_card: '信用卡（checkout）', // 信用卡（checkout）
//   cko_sofortbanking: 'cko_sofortbanking', // Sofortbanking（checkout）
//   cko_iDEAL: 'cko_iDEAL', // iDEAL（checkout）
//   affirm: 'affirm分期付', // 分期付款（美国）
//   worldpay: 'worldpay', // World Pay
//   transfer: '对公转账', // 对公转账
//   transfer_hk: '对公转账', // 对公转账（香港主体）
//   oversea_reseller_transfer: '海外分销对公转账', // 海外分销对公转账
//   domestic_reseller_transfer: '国内分销对公转账', // 国内分销对公转账
//   insta360: '市场领用', // 市场领用
//   insta360_borrow: '借用', // 借用
//   insta360_develop: '研发领用', // 研发领用
//   repairment_alipay: '支付宝（工单）', // 工单支付宝
//   repairment_weixin: '微信支付', // 微信app（工单）
//   repairment_weixin_qr: '微信支付', // 微信二维码（工单）
//   repairment_weixin_h5: '微信支付', // 微信h5页（工单）
//   repairment_paypal: 'Paypal支付（工单）', // 工单paypal
//   repairment_paypal_new: 'Paypal支付（工单）', // 工单paypal（新）
// };

// 支付 本次支付错误信息 payment preChannel字段对应值
// const paymentFailChannel = ['alipay', 'wechat', 'paypal', 'ocean', 'checkout'];

// 后端使用的卡种对应，第一个参数是前后已经约定好的creditcard_name，第二个是全称（支付机构会回传回来全称）、第三个是缩写，后端会将后两种对应上第一种约定好的
// /**
//  * AE卡种
//  */
// AE("ae", "AMERICAN EXPRESS", "AE"),

// /**
//  * Discover卡种
//  */
// DISCOVER("discover", "DISCOVER", "Discover"),

// /**
//  * Diners卡种
//  */
// DINERS("diners", "DINERS CLUB INTERNATIONAL", "Diners"),

// /**
//  * Visa卡种
//  */
// VISA("visa", "VISA", "Visa"),

// /**
//  * MasterCard卡种
//  */
// MASTER_CARD("mastercard", "MASTERCARD", "MC"),

// /**
//  * Jcb卡种
//  */
// JCB("jcb", "JCB", "JCB"),

// /**
//  * Maestro卡种
//  */
// MAESTRO("maestro", "MAESTRO", "Maestro"),

// /**
//  * UnionPay卡种
//  */
// Cup("unionpay", "CHINA UNION PAY", "CUP")
